import React, { memo } from 'react';
import { LazyLoadComponent } from 'react-lazy-load-image-component';
import { IconWidget } from '@weatherbug/react';
import styled from 'styled-components';
import { CommonContainerStyle } from '../hourlyForecast/styles';
import { largeMediaQuery, mediumMediaQuery, smallMediaQuery } from '../../../common/utilities/sizeHelpers';
import { reduxConnect } from '../../../common';

const forecastDailyPageId = 'forecasts/daily';
const defaultIconCode = 999;
interface ForecastCardIconProps {
    authId: string;
    secret: string;
    contentManagementBaseUrl: string;
    stdParameters: object;
    iconCode: number;
    iconSet: string;
    iconSize: string;
    resourceList: string;
    isDailyForecastPage: boolean;
}

const mapStoreStateToProps = (storeState: any) => {
    const appState = storeState.appState.appState || {};
    const { authId, secret, forecastBaseUrl, forecastIconResourceList, forecastIconSize, forecastIconSet, contentMgmtBaseUrl, stdParameters, pageId } = appState;
    const isDailyForecastPage = pageId?.toLowerCase() === forecastDailyPageId.toLowerCase();
    return {
        authId,
        secret,
        forecastBaseUrl,
        stdParameters,
        iconSet: forecastIconSet,
        iconSize: forecastIconSize,
        contentManagementBaseUrl: contentMgmtBaseUrl,
        resourceList: forecastIconResourceList,
        isDailyForecastPage
    };
};

const mapDispatchToProps = {};

export const ForecastCardIcon = memo(reduxConnect(mapStoreStateToProps, mapDispatchToProps)(({
    iconCode = defaultIconCode,
    iconSet,
    iconSize,
    authId,
    secret,
    contentManagementBaseUrl,
    stdParameters,
    resourceList,
    isDailyForecastPage
}: ForecastCardIconProps) => {
    return (
        <Container isDaily={isDailyForecastPage}>
            <LazyLoadComponent threshold={100} useIntersectionObserver={true}>
                <IconWidget 
                    iconCode={iconCode}
                    iconSet={iconSet}
                    iconSize={iconSize}
                    authId={authId}
                    secret={secret}
                    contentManagementBaseUrl={contentManagementBaseUrl}
                    stdParameters={stdParameters}
                    resourceList={resourceList}>
                </IconWidget>
            </LazyLoadComponent>
        </Container>
    );
}));

interface ContainerProps {
    isDaily: boolean;
}

const Container = styled.div<ContainerProps>`
    ${CommonContainerStyle}
    width: ${({ isDaily }) =>  isDaily ? '55px' : '59px'};
    height: ${({ isDaily }) =>  isDaily ? '55px' : '59px'};
    justify-content: center;
    & .wb-content-mgt-icon-image {
        width: 60px;
        height: 60px;
        @media ${smallMediaQuery} {
            width: 50px;
            height: 50px;
        }
    }
`;